// @flow
import styled from 'styled-components';
import {
  textNormal,
  textBlack,
  textBold,
  textBoldLoose,
  textSemiBold,
} from './css';
import { Text3 } from './Text';

export const Text3Normal = styled(Text3)`
  ${textNormal};
`;

export const Text3Black = styled(Text3)`
  ${textBlack};
`;

export const Text3SemiBold = styled(Text3)`
  ${textSemiBold};
`;

export const Text3Bold = styled(Text3)`
  ${textBold};
`;

export const Text3BoldLoose = styled(Text3)`
  ${textBoldLoose};
`;
